// Copyright (c) 2021, Comsearch, Inc., All rights reserved

import getPathIdsToUpdate from './getPathIdsToUpdate'

import updateMultiplePathsInProjectSummary from 'redux/modules/projectSummary/thunks/updateMultiplePathsInProjectSummary'
import { loadingToggler } from 'redux/modules/loading'

/**
 * @typedef {Object} callsignCascadeAggregateGroup
 * @property {Array<number>} matchedSegmentEndIds - segment end ids which should be cascaded with the trigger segment end data
 * @property {number} triggeredSegmentEndId - segment end id that was updated and has triggered the callsign cascade.
 */

/**
 * Takes callsign cascade update data
 * @param {Array<callsignCascadeAggregateGroup>} callsignCascadeData - this comes from Callsign Cascade redux form
 */

const updateProjectDataAfterCallsignCascadeSuccess = callsignCascadeData => (dispatch, getState) => (
  dispatch(loadingToggler(
    async () => {
      const paths = getState().projectSummary.get('paths')

      const pathsIdsToUpdate = getPathIdsToUpdate(callsignCascadeData, paths)

      if (pathsIdsToUpdate.length) {
        await dispatch(updateMultiplePathsInProjectSummary(pathsIdsToUpdate))
      }
    })
  )
)

export default updateProjectDataAfterCallsignCascadeSuccess
